import { Box, Icon, IconButton, Modal, ModalBody, Spacer, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { scrollbarStyle } from "../../theme/scrollbarStyles";
import useMobile from "../../hooks/useMobile";
import { ArrowLeft } from "../icons/icons";
import React, { useState, useEffect } from "react";
import { SafeArea } from "capacitor-plugin-safe-area";



interface PolicyItem {
    title: string;
    description: string;
}

interface PolicyModalProps {
    header: string;
    content: PolicyItem[];
    isOpen: boolean;
    onClose: () => void;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ isOpen, onClose, header, content }) => {
    const isMobile = useMobile(600)
    const [statusBarHeight, setStatusBarHeight] = useState<number>(0);

    useEffect(() => {
        SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
          setStatusBarHeight(statusBarHeight);
        });
      }, []);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside"
            size={isMobile ? 'full' : 'md'}
        >
            <ModalOverlay />
            <ModalContent p='0' borderRadius='10px' overflow='hidden'>
                {isMobile ? <></> : <ModalCloseButton />}
                <ModalBody p={isMobile ? '0px 20px 20px 20px' : '30px'} overflowY='scroll' mt='0' sx={scrollbarStyle}>
                    {isMobile ? 
                        <Box w='100%' p='20px 0'  position='sticky' top='0' bg='white' zIndex={1}>
                                      <Spacer h={statusBarHeight + "px"} />

                            <IconButton
                                minW='32px' h='32px'
                                variant='light'
                                aria-label="back"
                                onClick={onClose}
                                icon={<Icon width="20px" height="19px" viewBox="0 0 23 20">
                                    <ArrowLeft color='#171C22' />
                                </Icon>}
                            />
                        </Box> : <></>
                    }
                    <ModalHeader
                        p={isMobile ? '0 0 20px 0' : '0'}
                    >{header}</ModalHeader>
                    
                    {content.map((item, index) => (
                        <Box w='100%'>
                            <Text variant='title'
                                userSelect={'none'}
                                fontSize='17'
                                mb='6px' mt='16px'
                            >
                                {index}. {item.title}

                            </Text>
                            <Text variant='subtle'
                                userSelect={'none'}

                            >
                                {item.description}

                            </Text>
                        </Box>
                    ))}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default PolicyModal;
